/**
 * Created by PanJiaChen on 16/11/18.
 */
import { parseTime } from "@/utils/index";
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
	return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
	const valid_map = ['admin', 'editor']
	return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
	const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
	return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
	const reg = /^[a-z]+$/
	return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
	const reg = /^[A-Z]+$/
	return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
	const reg = /^[A-Za-z]+$/
	return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
	const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
	if (typeof str === 'string' || str instanceof String) {
		return true
	}
	return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
	if (typeof Array.isArray === 'undefined') {
		return Object.prototype.toString.call(arg) === '[object Array]'
	}
	return Array.isArray(arg)
}

/**
	checkIdenticalByte 校验连续相同字符最大长度
	@param str 字符串
	@param maxLen 最大长度
	@return {Boolean} {true: 小于最大长度, false: 大于等于最大长度}
*/
export function checkIdenticalByte(str, maxLen) {
	let num = 0
	let upByte = ' '
	for (let i = 0; i < str?.length; i++) {
		const b = str[i];
		if (upByte == ' ') {
			upByte = b
		}
		if (upByte == b) {
			num++
		} else {
			upByte = b
			num = 1
		}
		if (num >= maxLen) {
			return false
		}

	}
	return true
}

/**
	checkIdenticalByte 是否包含连续数字
	@param str 字符串
	@return {Boolean} 
*/
export function continuousNumber(str) {
	return str?.includes('123456') || str?.includes('12345') || str?.includes('654321') || str?.includes('54321')
}

/**
	是否大于当前时间
	@param rule 字符串
	@param value 字符串
	@param callback 函数
  自定义校验规则参见 async-validator  https://github.com/yiminghe/async-validator
*/
export function greaterTodayValidator(rule, value, callback) {
	let now = parseTime(new Date())
	if (value > now) {
		callback(new Error("不能大于当前时间！"))
	} else {
		callback()
	}
}
/**
	检查时间是否冲突
	@param data 时间数组
*/
export function isHasRepeatTime(data, params = {}) {
  const { startTimeKey = 'begin_time', endTimeKey = 'end_time' } = params
  const startTimeArr = []
  const endTimeArr = []
  data.forEach(item => {
    startTimeArr.push(item[startTimeKey])
    endTimeArr.push(item[endTimeKey])
  })
  const allStartTime = startTimeArr.sort()
  const allEndTime = endTimeArr.sort()
  let result = 0
  for (let k = 1; k < allStartTime.length; k++) {
    if (allStartTime[k] < allEndTime[k - 1]) {
      result += 1
    }
  }
  return result > 0
}

/**
	验证图片宽高
  @author 何硕
	@param file 图片文件 
  @param { width , height } 图片宽高
*/
//验证图片宽高
export function verifyImgWidthAndHeight(file, { width, height }) {
	return new Promise((resolve, reject) => {
		const _URL = window.URL || window.webkitURL
		const image = new Image()
		image.src = _URL.createObjectURL(file)
		image.onload = function () {
			let valid = width == image.width && height == image.height
			valid ? resolve() : reject()
		}
	})
}

/**
	isOrderID 判断一个字符串是否为合法的订单ID
	@param str 字符串
	@return {Boolean} 
*/

// 订单ID规则：16位数字
export function isOrderID(str) {
	// 首先检查是否为整数格式的字符串
	if (!/^[1-9]\d*$/.test(str)) 
		return false;
	// 将字符串转换为 BigInt
	let num;
	try {
		num = BigInt(str);
	} catch (e) {
		// 如果转换失败（例如，因为字符串太大或格式不正确）
		return false;
	}

	// 检查 num 是否在 64 位整数的范围内
	const maxInt64 = BigInt("9223372036854775807");  // 2^63 - 1
	return num >= 1 && num <= maxInt64;
}

// 工单id校验
export function isWorkID(str) {
	// 首先检查是否为整数格式的字符串
	if (!/^[1-9]\d*$/.test(str)) { 
		return false
	} 
	const num = Number(str)
	const maxInt32 = 2147483647 // 2^31 - 1
	return num >= 1 && num <= maxInt32 
}